import { createRoot } from "react-dom/client";

function isDomNode(target) {
    return Boolean(target) && typeof target === "object" && target.nodeType === 1;
}

export default function renderWidget(first, second) {
    const container = isDomNode(first) ? first : second;
    const element = isDomNode(first) ? second : first;

    if (!isDomNode(container)) {
        throw new Error("Unable to locate the root element for the widget.");
    }

    if (!element) {
        throw new Error("Attempted to render an undefined React element.");
    }

    const root = createRoot(container);
    root.render(element);

    return root;
}
